import React from "react";
import LoginForm from "../organisms/login/LoginForm";
import Heading from "../atoms/Heading";
import LOGO from '../../assets/logos/logoRSazul.jpeg';
import FONDO from '../../assets/logos/IMG_0065.JPG';

const LoginTemplate = () => {
    return(
        <div className="relative min-h-screen w-full flex flex-col justify-center items-center text-center overflow-hidden">
            <img
                src={FONDO}
                className="absolute inset-0 w-full h-full object-cover"
                alt="Fondo"
            />
            <div className="absolute inset-0 bg-rs-azul/80"></div>
            <div className="relative z-10 p-4 flex flex-col items-center space-y-4">
                <img src={LOGO} className="h-64 aspect-square rounded-full" alt="Logo Ramirez soto"/>
                <Heading text="Ramírez Soto Administración" color="white" />
                <LoginForm/>
                <a href="/" className='text-[#e73842] text-base font-semibold'>Volver al inicio</a>
            </div>
        </div>
    )
};

export default LoginTemplate;